import React, { useRef } from 'react';
import { Box } from '../../Box';

type SliderGrabberProps = {
    /** The width of our parent container. */
    trackWidth: number;
    /** Our % position within our parent container. */
    perc: number;
    /** A method that's called when the grabber is dragged, and whether it's done dragging. */
    onDrag: (newValue: number, finished: boolean) => void;
};

const SliderGrabber = ({ perc, trackWidth, onDrag, ...props }: SliderGrabberProps) => {
    const dragRef = useRef<any>(null);
    const mouseX = useRef<number>(0);

    const OnMouseDown = (e: any) => {
        mouseX.current = e.clientX;

        window.addEventListener('mouseup', OnMouseUp);
        window.addEventListener('mousemove', OnMouseMove);
    };

    const OnMouseUp = (e: any) => {
        const delta = e.clientX - mouseX.current;
        onDrag && onDrag(delta, true);

        window.removeEventListener('mouseup', OnMouseUp);
        window.removeEventListener('mousemove', OnMouseMove);
    };

    const OnMouseMove = (e: any) => {
        const delta = e.clientX - mouseX.current;
        onDrag && onDrag(delta, false);
    };

    return (
        <Box
            draggable={false}
            className="slider-point-container"
            center="all"
            ref={dragRef}
            style={{
                left: `${perc * trackWidth}px`,
                top: '0px',
            }}
            onMouseDown={OnMouseDown}
        >
            <Box
                draggable={false}
                className="slider-point"
                onDragStart={(e: any) => {
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                }}
            />
        </Box>
    );
};

export default SliderGrabber;
